export const authAreaPluggable = {
  lazyRoutes: [
    {
      path: 'auth',
      loadChildren: () => import('./auth-area.module').then((m) => m.AuthAreaModule),
    },
  ],
};
